import { observer } from 'mobx-react-lite';
import { ViewType } from 'owa-calendar-actions';
import CalendarEventBody from 'owa-calendar-forms-common/lib/components/CalendarEventBody';
import DataRow from 'owa-calendar-forms-common/lib/components/DataRow';
import { hasVisibleContentInBody } from 'owa-calendar-forms-utils/lib/utils/hasVisibleContentInBody';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import * as React from 'react';
import { notesAccessibility } from './PeekEventContent.locstring.json';
import ShowMoreButton from './ShowMoreButton';

const styles = require('./CalendarItemPeek.scss');
const classNames = require('classnames');

interface PeekEventBodyRowProps {
    item: CalendarEvent;
    colorScheme: ColorScheme;
    allowFullBody: boolean;
    actionSource: ViewType;
}

export default observer(function PeekEventBodyRow(props: PeekEventBodyRowProps) {
    const { item, colorScheme, allowFullBody, actionSource } = props;

    const [showFullBody, setShowFullBody] = React.useState<boolean>(false);

    const onToggleFullBodyButtonClick = React.useCallback(() => {
        setShowFullBody(!showFullBody);
    }, [showFullBody]);

    const canShowFullBodyContent = allowFullBody && hasVisibleContentInBody(item);

    return (
        <DataRow
            iconName={ControlIcons.List}
            iconClassName={classNames(styles.contentIcon, styles.peekContentIcon)}
            childrenClassName={styles.previewTextContainer}
            childrenAriaLabel={loc(notesAccessibility)}>
            <div className={styles.previewText}>
                <span>
                    {canShowFullBodyContent && showFullBody ? (
                        <CalendarEventBody calendarEvent={item} viewType={actionSource} />
                    ) : (
                        item.Preview
                    )}
                </span>
                {canShowFullBodyContent && (
                    <ShowMoreButton
                        onClick={onToggleFullBodyButtonClick}
                        shouldShowMore={!showFullBody}
                        colorScheme={colorScheme}
                    />
                )}
            </div>
        </DataRow>
    );
});
